/**
 * 提及信息卡的回查缓存：同一个 id 在整个会话期间只请求一次。
 * 失败不写缓存，下次 hover 可以重试。
 */
const cache = new Map<string, Promise<unknown>>();

export function lookupCached<T>(key: string, loader: () => Promise<T>): Promise<T> {
  let hit = cache.get(key) as Promise<T> | undefined;
  if (!hit) {
    hit = loader().catch((error) => {
      cache.delete(key);
      throw error;
    });
    cache.set(key, hit);
  }
  return hit;
}

/** 仅供测试重置状态 */
export function clearMentionCache() {
  cache.clear();
}
